import React, { Component } from 'react'
import find from 'lodash/find'
import TopPageHeader from '../../components/pageHeaders/TopPageHeader'
import StickyPageHeader from '../../components/pageHeaders/StickyPageHeader'
import Dropdown from '../../components/uiKit/Dropdown'
import Button from '../../components/uiKit/Button'
import DropdownItem from '../../components/uiKit/DropdownItem'
import DropdownDivider from '../../components/uiKit/DropdownDivider'
import Icon from '../../components/misc/Icons'
import {Image} from 'cloudinary-react'
import ProfilePic from '../../components/ProfilePic'
import {newSet,newQuestion} from '../../utils/newItem'
import PageIcon from '../../components/misc/PageIcons'
import {getUserNameForId} from '../../utils/getUserNameForId'


class FolderNameInput extends Component {
	constructor(props){
		super(props)
		this.handleKeyDown=this.handleKeyDown.bind(this)
		this.state=({ 
 			folderName:props.folder.name
 		})
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
 		if(nextProps.folder){
 			if(nextProps.folder.id !==this.props.folder.id){
 				this.setState({folderName:nextProps.folder.name})
 			}
 		}else{
 			this.setState({folderName:null})
 		}
 	}

 	handleKeyDown(e){
 		if (e.keyCode === 13) { 
 			e.preventDefault()
			this.props.editFolderName(this.props.folder,this.state.folderName)
			document.getElementById('pageHeaderFolderNameInput').blur()
		}
 	}


	render(){	
		const {readOnlyFolder,folder}=this.props
		const {folderName}=this.state

		return(		
			<input 
				disabled={readOnlyFolder || this.props.readOnlyPrivileges}
				maxLength={100}
				className='pageHeader-folderTitle'
				id='pageHeaderFolderNameInput'
				placeholder='Enter Folder Name'
				value={this.state.folderName || ''}
				onChange={(e)=>{this.setState({folderName:e.target.value})}}
				onBlur={()=>{this.props.editFolderName(folder,folderName)}} 
				onKeyDown={this.handleKeyDown}
			/>

		)}
}







class RepoPageHeaders extends Component {
 
	constructor(){
		super()
		this.renderPathItem=this.renderPathItem.bind(this)
	}

	renderPathItem(pathItem,index){
		const folder=find(this.props.allFolders,{'id':pathItem})	
		if(folder){
			return(
				<div className='pageHeaderTop-folderNavRow-folderPathItem is--folder' onClick={() =>{this.props.navigateToFolder(pathItem)}} key={index}>
					<Icon name='chevron-right'/>
					<Icon name='folder'/>					       
					{folder.name}
				</div>
			)
		}else{
			return null
		}
	}





	render() { 

		const {repo,parentFolder,readOnlyPrivileges,isViewer,isPending,repoDisabled,uploadingImage,parentFolderId,permissionsJoined}=this.props

		let countJoinedPermissions
		if(permissionsJoined){
			countJoinedPermissions = permissionsJoined.length
		}

		let readOnly=false

		let folderPath=[]
		let folderNavRow

		if(parentFolder){
			readOnly=parentFolder.readOnly
			folderPath=parentFolder.ancestors.slice().reverse()

			folderNavRow=
				<React.Fragment>															
					<div className='pageHeaderTop-folderNavRow-folderPathItem is--library' onClick={()=>{this.props.navigateToFolder()}}>
						{repo.shared && <Icon name='shared'/>} {repo.name}
					</div>
					
					{folderPath.map((pathItem,index) => ( this.renderPathItem(pathItem,index)))}						

					<div className='pageHeaderTop-folderNavRow-folderPathItem is--folder is--currentFolder'>
			        <Icon name='chevron-right'/>
			        <Icon name={!readOnly ? 'folder' : 'folder-isbe' }/>					        
			          {parentFolder.name}				        
					  </div>
				</React.Fragment>
		}

		let RepoPageHeaderActions =
			<React.Fragment>
				{/* Default Action Row */}
				{!readOnlyPrivileges && 
					<React.Fragment>
						<Button iconName='compose' label={parentFolder ? 'New Set in Folder' : 'New Set'} onClickFunction={()=>{newSet(parentFolderId,repo.id)}} />
						
						<div className='pageHeaderTop-actionRow-spacer' />
						<Button iconName='folder-outline' tooltipLabel='New Folder' tooltipPosition='label'  onClickFunction={this.props.handleNewFolder}/>
						<Dropdown>						
							<DropdownItem label={parentFolder ? 'New Question in Folder' : 'New Question'} onSelect={()=>{newQuestion(parentFolderId,repo.id)}} />
							<DropdownDivider />			
							<DropdownItem label='Edit Pack Details' onSelect={()=>{this.props.showEditRepoModal(repo)}}/>
							<DropdownItem label='View Trash' onSelect={this.props.navigateToTrash} />							
							<DropdownDivider />	
							{repo.shared &&
								<DropdownItem warning label='Leave Pack' onSelect={this.props.confirmLeaveRepo} />
							}
							{!repo.shared &&
								<DropdownItem warning label='Delete Pack' onSelect={this.props.confirmDeleteRepo} />
							}
						</Dropdown>	
					</React.Fragment>
				}

					{/* If not joined, then show inline member list */}
					{!parentFolder && permissionsJoined && isPending &&									
						<div className={'pageHeaderTop-actionRow--repoMemberList ' + (countJoinedPermissions > 4 ? 'pageHeaderTop-actionRow--repoMemberList--shortForm' : 'pageHeaderTop-actionRow--repoMemberList--longForm')}>
							{permissionsJoined.map((permission,i)=>{
			 					const userDisplayName=getUserNameForId(permission.user.id,repo.id)
				 								 				
			 					let repoMemberListShortForm = true // show short-form style with name tag if small number of members
			 					if(countJoinedPermissions < 2){
			 						repoMemberListShortForm = false
			 					}
			 					return(
			 						<React.Fragment key={i}>
				 						<div data-tooltip={userDisplayName} className={'pageHeaderTop-actionRow--repoMemberList-repoMember tooltip tooltip--label ' + (repoMemberListShortForm ? 'pageHeaderTop-actionRow--repoMemberList-repoMember--shortForm':'pageHeaderTop-actionRow--repoMemberList-repoMember--longForm')} >				 							
			 								<ProfilePic size='30' borderRadius='4' key={i} user={permission.user} />
			 								<div className='pageHeaderTop-actionRow--repoMemberList-repoMember-name'>{userDisplayName}</div>
				 						</div>				 					
			 						</React.Fragment>
			 						)
			 				})}
			 				
							{countJoinedPermissions > 10 && 
							<div className='pageHeaderTop-actionRow--repoMemberList-overflow'>							
			 					and {countJoinedPermissions - 10} more
			 				</div>
			 				}
						</div>
					}
						
				{/* If viewer, show dropdown to leave and read-only access message */}

				{isViewer && !isPending && !repoDisabled && !parentFolder &&
					<React.Fragment>						
						<div className='pageHeaderTop-actionRow-viewOnlyBanner'>
							View only 
						</div>
						<div className='pageHeaderTop-actionRow-spacer' />
						{repo.shared &&
							<Dropdown>														
								<DropdownItem warning label='Leave Pack' onSelect={this.props.confirmLeaveRepo} />
							</Dropdown>	
						}													
					</React.Fragment>
				}

		</React.Fragment>



 	if(!parentFolder){
			return (
    			<React.Fragment>
					<TopPageHeader
						location='repo'
						leftBadge={
							<React.Fragment>								
								{repo.image &&
									<div className='pageHeaderTop-leftBadge-repoImageContainer' onClick={()=>{this.props.showEditRepoModal(repo)}}>
										<Image
											key={repo.id}						
											cloudName={process.env.REACT_APP_CLOUDINARY_CLOUDNAME}
											publicId={`${repo.image}/repo/${repo.id}`} 
											className='pageHeaderTop-leftBadge-repoImage'											
											width='450'
											height='450'
											crop='fill'
										/>
									</div>
								}								
							</React.Fragment>
						}
						header={repo.name}
						headerRowClickFunction={()=>{
							if(!readOnlyPrivileges){
								this.props.showEditRepoModal(repo)
							}
						}}
						leftBadgeClickFunction={()=>{
							if(!readOnlyPrivileges){
								this.props.showEditRepoModal(repo)
							}
						}}						
						headerInfoRowClickFunction={()=>{
							if(!readOnlyPrivileges){
								this.props.showEditRepoModal(repo)
							}
						}}
						headerInfoRow={repo.description}
						actionRow={RepoPageHeaderActions}						
						repoWithImage={repo.image || uploadingImage}
						viewOnlyRepoPrivileges={readOnlyPrivileges}
						repoTextOnly={!repo.image && !uploadingImage}
						multiLine
						rightBadge={
							<React.Fragment>
								{repo.shared &&
									<Icon name='shared' />
								}
							</React.Fragment>
						}
					/>

					<StickyPageHeader 
						location='repo' 
						leftBadge={
							<React.Fragment>							
								{repo.image &&						
									<div className='pageHeaderSticky-leftBadge-repoImageContainer'>												
										<Image	
											key={repo.id}					
											cloudName={process.env.REACT_APP_CLOUDINARY_CLOUDNAME}
											publicId={`${repo.image}/repo/${repo.id}`} 
											className='pageHeaderSticky-leftBadge-repoImage'
											width='450'
											height='450'
											crop='fill'
										/>											
									</div>
								}
							</React.Fragment>
						}
						header={repo.name}
						actionGroup={RepoPageHeaderActions}							
					/>	
				</React.Fragment>					
			)}
		else return(
			<React.Fragment>
				<TopPageHeader
					location='repoFolder' 								
					leftBadge={
						<React.Fragment>
							<Icon name='chevron-left' />
							<PageIcon name='libraryLarge' />
						</React.Fragment>}
					leftBadgeClickFunction={()=>{
						if(folderPath.length===0){
							this.props.navigateToFolder()	
						}else{
							this.props.navigateToFolder(folderPath[folderPath.length-1])
						} }}
					header={ 
						<FolderNameInput
							path={folderPath}
							readOnlyFolder={readOnly}
							allFolders={this.props.allFolders}
							navigateToFolder={this.props.navigateToFolder}
							editFolderName={this.props.editFolderName}
							folder={this.props.parentFolder}
							readOnlyPrivileges={readOnlyPrivileges}
						/>}						
					folderNavRow={folderNavRow}
					actionRow={RepoPageHeaderActions}
					height={readOnlyPrivileges ? '140': '175'}
				/>
					
					<StickyPageHeader 
						location='repoFolder' 
						leftBadge={
								<React.Fragment>
									<Icon name='chevron-left' />
									<PageIcon name='libraryLarge' />
								</React.Fragment>
							}
						leftBadgeClickFunction={()=>{
							if(folderPath.length===0){
								this.navigateToFolder()	
							}else{
								this.navigateToFolder(folderPath[folderPath.length-1])
								}  }}
						header={this.props.parentFolder.name}
						actionGroup={RepoPageHeaderActions}
					/>

							</React.Fragment>
						)}
}





export default RepoPageHeaders


// WEBPACK FOOTER //
// ./src/components/repo/RepoPageHeaders.js